import AbstractView = require("./abstract/AbstractView");
import 'owl.carousel';
import HiddenLayer = require("./HiddenLayer");


class QualityView extends AbstractView {

    constructor(id: number, selector: JQuery) {
        super(id, selector);
    }

    init(): void {
        this.createHiddenCon();
    }


    onScroll(containerTop: number): void {

        this.mainScrollTop = containerTop;
        if (!this.isTrigger) return;
        if (this.$triggerBtn) {
            let templateOffsetTop: number = this.$triggerBtnCon.offset().top - containerTop;
            let navHeight = $("#overview-top-nav").height() == null ? 60 : $("#overview-top-nav").height();
            if (templateOffsetTop <= navHeight) {
                this.$triggerBtn.css({
                    "position": "fixed",
                    "top": 0
                });
            } else {
                this.reset();
            }
        }
    }

    reset(): void {
        if (this.$triggerBtn) {
            this.$triggerBtn.css({
                "position": "absolute",
                "top": "auto"
            });
        }
    }

    private isTrigger: boolean;
    private $triggerBtnCon: JQuery;
    private $triggerBtn: JQuery;
    private hiddenLayer: HiddenLayer;
    private mainScrollTop: number;

    private createHiddenCon(): void {

        this.isTrigger = false;
        this.hiddenLayer = new HiddenLayer(this.getChildBySelector(".hiddenCon"));
        this.$triggerBtnCon = this.$template.find(".triggerCon");
        this.$triggerBtn = this.$triggerBtnCon.find(".triggerBtn");
        this.$triggerBtn.on("click tap", (event: JQuery.Event) => {
            event.preventDefault();
            this.isTrigger = !this.isTrigger;
            if (this.isTrigger) {
                this.$triggerBtn.addClass("active");
                this.hiddenLayer.transitionIn();
            } else {
                this.hiddenLayer.transitionOut();
                this.$triggerBtn.removeClass("active");
                this.reset();
                let targetTop: number = this.mainScrollTop + (this.$triggerBtnCon.offset().top - this.mainScrollTop);
                this.emitter.emit(AbstractView.ViewEvent.ScrollTo, targetTop);
            }
        });
    }


}

export = QualityView;